const InputDimension = ({ dimension, handleInputDimension, classNameStyle, id = 'serial-number-input' }) => {
    return (
        <input
            id={id}
            className={classNameStyle}
            value={dimension}
            onChange={handleInputDimension}
        />
    );
};

export default InputDimension;
